const createLogoSizeValidator = (validationError, maxSize) => (file) => {
  if (file && file?.size > maxSize) {
    return validationError;
  }

  return null;
};

export default createLogoSizeValidator;
